export async function publishProjectStatus(
    data: any,
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>
) {
    let apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/pos/public`;
    try {
        const result = await fetchGlobal<any>(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });

        return result;
    } catch (error) {
        console.error("Error publishing project status:", error);
    }
}
